"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageWrapper = void 0;
var React = require("react");
var ErrorMessageWrapper_st_css_1 = require("./ErrorMessageWrapper.st.css");
exports.ErrorMessageWrapper = function (props) {
    var render = props.render, error = props.error, disabled = props.disabled, errorMessage = props.errorMessage, className = props.className;
    var inErrorState = error && !disabled && !!errorMessage;
    return (React.createElement("div", { className: ErrorMessageWrapper_st_css_1.st(ErrorMessageWrapper_st_css_1.classes.root, className), "data-hook": props['data-hook'] },
        render({ error: inErrorState }),
        inErrorState && (React.createElement("div", { className: ErrorMessageWrapper_st_css_1.classes.errorMessage }, errorMessage))));
};
//# sourceMappingURL=ErrorMessageWrapper.js.map